// extracted by mini-css-extract-plugin
module.exports = {"maxWidthMedium":"utilities-module--maxWidthMedium--3f6K0"};